// @flow

import React from 'react';
import placeholderImage from 'img/fallback/logo_image_item_file_default.png';
import { LIKEABLE_TYPE_COMPANY } from 'core/constants/likes';
import { searchJobs as t } from 'helpers/translation';
import capitalize from 'helpers/capitalize';
import TrackEvent from 'components/TrackEvent';
import Like from 'components/Like';

type Props = {
  company: {
    id: number | string,
    name: string,
    titleDe: string,
    onlineJobsCount: number | string,
    jobsUrl: string,
    pageUrl: string,
    industry: any,
    type: string,
    typeLabel: string,
    logoImageItem: any
  },
  company: any,
  user: any,
  isCurrentUser: boolean,
  handleLike: Function,
  classes: string,
  trackEventName: string
};

export default ({
  company: {
    id,
    name,
    titleDe,
    onlineJobsCount,
    jobsUrl,
    pageUrl,
    industry,
    type,
    typeLabel,
    logoImageItem
  },
  company,
  user,
  isCurrentUser,
  handleLike,
  classes,
  trackEventName
}: Props) => (
  <div className={classes || 'col-12 col-md-6 col-lg-4'}>
    <div className={`card card_company${type ? ` card_${type}` : ''}`}>
      {typeLabel ? <div className="card__label">{typeLabel}</div> : ''}
      <div className="card__body">
        <a href={pageUrl} target="_blank" rel="noreferrer" className="card__img no-padding">
          <img
            src={logoImageItem && logoImageItem.file ? logoImageItem.file.profile.url : placeholderImage}
            title={logoImageItem ? logoImageItem.title : ''}
            alt={logoImageItem ? logoImageItem.title : ''}
          />
        </a>
        <a href={pageUrl} target="_blank" rel="noreferrer" className="card__title">
          {company[`title${capitalize(locale)}`] || titleDe}
        </a>
        <a href={industry.pageUrl} target="_blank" rel="noreferrer" className="card__subtitle">{industry.name}</a>
      </div>
      <div className="card__footer">
        <a href={jobsUrl} className="card__jobs-count">{onlineJobsCount} {t.company.jobs}</a>
        <Like id={id} user={user} isCurrentUser={isCurrentUser} handleLike={handleLike} type={LIKEABLE_TYPE_COMPANY}/>
      </div>
    </div>
    <TrackEvent name={trackEventName} properties={{
      company_id: id,
      company_name: name
    }}/>
  </div>
);
